import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import {loadConfig} from "./configLoader";

Vue.config.productionTip = false;

// new Vue({
//   vuetify,
//   router,
//   render: h => h(App)
// }).$mount('#app');

loadConfig().then(config => {
    Vue.prototype.$config = config;

    new Vue({
        vuetify,
        router,
        render: h => h(App)
    }).$mount("#app");
})
    .catch(error => {
        console.error("Konfigurationsfehler:", error);
    });
